import React, { useContext, useState } from 'react';
import { CustomersContext, ICustomersContext } from '../../../../../../../customersState/customersContext';
import { RequestEntity, IItemCustomer } from 'types';
import Button from 'components/Button/Button';
import Text from 'components/Text/Text';
import ImgUploaderByEntityId from 'components/ImgUploader/ImgUploaderByEntityId';
import { FullInfoBtn } from '../../../../FullInfoBtn/FullInfoBtn';
import AdditionalInfoSwitch from './components/AdditionalInfoSwitch';
import MainInfoView from './components/MainInfoView';
import AdditionallyInfoView from './components/AdditionallyInfoView';
import classNames from 'classnames';
import style from './Info.module.scss';

interface IInfo {
	isOpenInfo: boolean;
	data: IItemCustomer;
}

const Info: React.FC<IInfo> = ({ isOpenInfo, data }) => {
	const { setFullInfoData } = useContext<ICustomersContext>(CustomersContext);
	const [infoMode, setInfoMode] = useState<'main' | 'additional'>('main');
	const isDeleted = !!data.deletedDate;
	const containerClasses = classNames(style.container, { [style.visible]: isOpenInfo });
	const imgWrapperClass = classNames(style.imgWrapper, { [style.itemDisabled]: isDeleted });

	const handleSetFullInfo = () => {
		setFullInfoData(data.id);
	};

	const handleOpenSoftwareUpdates = () => {
		setFullInfoData(data.id, 'softwareForm');
	};

	return (
		<div className={containerClasses} data-test="Info">
			<AdditionalInfoSwitch infoMode={infoMode} setInfoMode={setInfoMode} />
			<div className={style.wrapper}>
				<div className={style.infoContainer}>
					<div className={imgWrapperClass}>
						<ImgUploaderByEntityId
							resource={RequestEntity.Customers}
							entityID={data.filePath ? data.id : ''}
							photoSize="Small"
							isMakeImageRequest={isOpenInfo}
							loaderSize="small"
							noImageIdIcon="customerDefaultAvatar"
						/>
					</div>
					{infoMode === 'main' ? <MainInfoView data={data} /> : <AdditionallyInfoView data={data} />}
				</div>
				<div className={style.fullInfoBtn}>
					<Button className={style.pushesButton} onClick={handleOpenSoftwareUpdates}>
						<Text translationNameSpace="form" translationKey="pushesButton" asFragment={true} />
					</Button>
					<FullInfoBtn onClick={handleSetFullInfo} />
				</div>
			</div>
		</div>
	);
};

export default React.memo(Info);
